// RolNoAutorizado / SoloCliente — UX para el caso "usuario logueado con rol != cliente intenta comprar".
//
// FIX B (Nico): antes, un logueado no-cliente (repartidor/marketing/portero…) que caía en /checkout o
// /cliente/pagar-pedido era rebotado en SILENCIO (a /catalogo o a home vía RequireAuth) → parecía un bug
// de pago. Ahora ve un mensaje claro con salida. Los 3 "bugs" reportados eran esto: martinjaime = rol
// repartidor. Un cliente real pasa sin ver esta pantalla.
//
//  • <RolNoAutorizado/> — la pantalla del mensaje. La usa RequireAuth (prop deniedFallback) en las rutas
//    de compra ya autenticadas (pagar-pedido) y SoloCliente en /checkout.
//  • <SoloCliente> — wrapper para /checkout: deja pasar VISITANTES (checkout público one-shot) y a
//    cliente/admin/superadmin; a cualquier otro rol logueado le muestra <RolNoAutorizado/>.
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import { supabase } from '../lib/supabase';

const ROL_LABEL = {
  repartidor: 'repartidor',
  admin: 'administrador',
  superadmin: 'administrador',
  marketing: 'marketing',
  portero: 'portero',
};

const ROLES_COMPRA = ['cliente', 'admin', 'superadmin'];

export function RolNoAutorizado() {
  const { role } = useAuth();
  const navigate = useNavigate();
  const rolTxt = ROL_LABEL[role] || role || 'una cuenta interna';

  async function cerrarSesion() {
    try { await supabase.auth.signOut(); } catch { /* noop */ }
    navigate('/login');
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#070b14', color: '#f1f5f9',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div style={{
        maxWidth: 460, width: '100%', textAlign: 'center',
        background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 20, padding: 32,
      }}>
        <div style={{ fontSize: 56, marginBottom: 12 }}>🔒</div>
        <h1 style={{ fontSize: 24, fontWeight: 800, margin: '0 0 10px', letterSpacing: '-0.02em' }}>
          Esta cuenta no puede comprar
        </h1>
        <p style={{ fontSize: 14, lineHeight: 1.55, color: 'rgba(248,246,241,0.65)', margin: '0 0 24px' }}>
          Tu cuenta está registrada como <strong style={{ color: '#f1f5f9' }}>{rolTxt}</strong>. Para comprar
          necesitás una cuenta de cliente. Cerrá sesión y creá una cuenta nueva, o pedí al admin que te
          cambie el rol.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button onClick={cerrarSesion} style={{
            background: 'linear-gradient(135deg, #00A8B5 0%, #00C4D4 100%)', color: '#0A1424',
            border: 0, borderRadius: 12, padding: '14px 20px', fontSize: 15, fontWeight: 800,
            cursor: 'pointer', fontFamily: 'inherit',
          }}>Cerrar sesión</button>
          <a href="https://limpack.uy" style={{
            display: 'block', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)',
            color: '#f1f5f9', borderRadius: 12, padding: '13px 20px', fontSize: 14, fontWeight: 700,
            textDecoration: 'none',
          }}>Ir a la tienda</a>
        </div>
      </div>
    </div>
  );
}

export function SoloCliente({ children }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="loading">Cargando...</div>;
  if (!user) return children;                          // visitante → checkout público one-shot
  if (ROLES_COMPRA.includes(role)) return children;    // cliente / admin / superadmin
  return <RolNoAutorizado />;                           // logueado con otro rol → mensaje claro
}
